import { DropdownItem, DropdownMenu, DropdownToggle, Input, UncontrolledDropdown } from "reactstrap";
import { selectOrganization } from "../../user/services/store/user.actions";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useUserAuthentication from "../../_hooks/useUserAuthentication";
import styled from "styled-components";
import stringUtils from "../../_services/string-utils";

const OrganizationDropdownMenu = () => {
    const authentication = useSelector((state) => state.authentication);

    const dispatch = useDispatch();

    const { selectedOrganization, isSuperUser } = useUserAuthentication();

    useEffect(() => {}, [selectedOrganization]);

    const [organizationFilterString, setOrganizationFilterString] = useState("");

    const sortedAvailableOrganisations = useMemo(() => {
        if (!(authentication.user && authentication.user.availableOrganizations)) {
            return [];
        }
        const orgs = [...authentication.user.availableOrganizations];
        if (authentication.user.platformUserType === "TAXCONSULTANT") {
            orgs.sort((a, b) => {
                if (a.taxAgency && !b.taxAgency) return -1;
                if (!a.taxAgency && b.taxAgency) return 1;
                return 0;
            });
        }
        return orgs;
    }, [authentication.user]);

    const viewableOrganisations = useMemo(() => {
        if (!sortedAvailableOrganisations || sortedAvailableOrganisations.length === 0) {
            return [];
        } else if (stringUtils.isBlank(organizationFilterString)) {
            return sortedAvailableOrganisations;
        }

        return sortedAvailableOrganisations.filter((organization) =>
            organization.name.toUpperCase().includes(organizationFilterString.toUpperCase())
        );
    }, [sortedAvailableOrganisations, organizationFilterString]);

    return (
        <UncontrolledDropdown direction="down">
            {authentication.user &&
            authentication.user.availableOrganizations &&
            authentication.user.availableOrganizations.length > 1 ? (
                <DropdownToggle nav style={{ paddingBottom: ".5em" }}>
                    <h6 style={{ marginBottom: "0" }} data-cy="select-organization-toggle">
                        {selectedOrganization?.name} <i className="fas fa-caret-down" />
                    </h6>
                </DropdownToggle>
            ) : (
                <p style={{ fontWeight: "bolder", marginBottom: "0" }}>{selectedOrganization?.name}</p>
            )}

            <DropdownMenu
                end
                style={{
                    width: "100%",
                    maxHeight: "500px",
                    minWidth: "300px",
                    overflow: "auto",
                    transform: "translate3d(-531px, 16px, 0px) !important",
                    right: "auto !important",
                }}
            >
                {authentication.user &&
                    authentication.user.availableOrganizations &&
                    authentication.user.availableOrganizations.length > 1 && (
                        <OrganizationItem header tag="div" className="text-center bg-dark-subtle">
                            <strong>Organisation wechseln</strong>
                        </OrganizationItem>
                    )}
                {authentication.user &&
                    isSuperUser &&
                    authentication.user.availableOrganizations &&
                    authentication.user.availableOrganizations.length > 1 && (
                        <Input
                            style={{ margin: "0", borderRadius: "0" }}
                            placeholder="Organisation suchen..."
                            onChange={(e) => setOrganizationFilterString(e.target.value)}
                            value={organizationFilterString}
                        />
                    )}
                {viewableOrganisations &&
                    viewableOrganisations.length > 0 &&
                    viewableOrganisations.map((org, i) => {
                        if (
                            authentication.user &&
                            authentication.user.selectedOrganization &&
                            org.externalUUID !== authentication.user.selectedOrganization.externalUUID
                        ) {
                            return (
                                <OrganizationItem
                                    key={i}
                                    onClick={() => {
                                        dispatch(selectOrganization(org.externalUUID, true)).then(() => {
                                            setOrganizationFilterString("");
                                        });
                                    }}
                                >
                                    {org.name}
                                </OrganizationItem>
                            );
                        } else {
                            return <React.Fragment key={i} />;
                        }
                    })}
            </DropdownMenu>
        </UncontrolledDropdown>
    );
};

export default OrganizationDropdownMenu;

const OrganizationItem = styled(DropdownItem)`
    border-bottom: 1px solid #c8ced3;
`;
